module.exports = __webpack_public_path__ + "img/step17_a_stand_power_remove_plastic_bag_from_stacker_tray-optionb.c53be810.png";